<template>
  <div class="swiper">
    <van-swipe :autoplay="3000" :show-indicators="false">
      <van-swipe-item v-for="(item, index) in list" :key="index">
        <div class="img">
          <img v-lazy="item.prizePicture" />
        </div>
        <div class="cont">
          <h2>{{ item.award }}</h2>
          <p>{{ item.prize }}</p>
          <h3>
            <span>{{ item.leftNum }}/</span>{{ item.winNum }}
          </h3>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
Vue.use(Lazyload);
import { lotteryPrizeList } from "@/api/index";
export default {
  data() {
    return {
      images: [
        "https://img01.yzcdn.cn/vant/apple-1.jpg",
        "https://img01.yzcdn.cn/vant/apple-2.jpg",
      ],
      lotteryId: "1683689464171335681",
      list: [],
    };
  },
  created() {
    if (this.$route.query.lotteryId) {
      this.lotteryId = this.$route.query.lotteryId;
    }
    this.getGiftList();
  },
  mounted() {
    setInterval(() => {
      this.getGiftList();
    }, 1000 * 60 * 10);
  },
  methods: {
    getGiftList() {
      lotteryPrizeList({ lotteryId: this.lotteryId }).then((res) => {
        this.list = res?.page?.list;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* prettier-ignore */
.swiper {
    padding: 20PX 15PX 0 20PX;
    height: 900PX;
    width: 455PX;
    color: #fff;
  .img {
    height: 618PX;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        margin-top: 20PX;
        max-width: 100%;
    }
  }
  .cont{
    color: #fff;
    text-align: center;
    h2{
        color: #FFB155;
        font-size: 30PX;
    }
    p{
        font-size: 25PX;
        margin-bottom: 20PX;
    }
    h3{
        font-size: 20PX;
        span{
            font-size: 25PX;
        }
    }
  }
}
</style>
